import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import LearningOutcomeLabel from '../../../components/v2/LearningOutcomeLabel';
import DepartmentHeader from '../../../components/v2/DepartmentHeader';

const FAST_URL = process.env.REACT_APP_DS_API_URL
const base_url = FAST_URL + "/setup/"

export default function SetupViewPage({props}) {
    const [ setup , setSetup ] = useState(null)
    const { setupId } = useParams('setupId')
    const [ departments, setDepartments ] = useState([])
    const [ learningOutcomes, setLearningOutcomes ] = useState({})
    const [ department, setDepartment ] = useState(null)

    useEffect(() => {
        let url = base_url + setupId
        console.log(url)
        fetch(url)
        .then(response => {
            return response.json();
        }).then(data => {
            setSetup(data)
            setDepartment(data.department)
        })
        .catch(err => console.log(err));
    }, [setupId])

    useEffect(() => {
        let url = FAST_URL + "/department"
        fetch(url)
        .then(response => {
            return response.json()
        })
        .then(data => {
            setDepartments(data)
        })
        .catch(err => {
            console.log(err)
        })
    }, [setupId])

    useEffect(() => {
        if (department) {
            let url = FAST_URL + "/learning-outcome/active/" + department.departmentId
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let currentSlos = {...learningOutcomes}
                currentSlos[department.departmentId] = data
                setLearningOutcomes({...currentSlos})
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [department])

    const formatYesNo = (val) => {
        let formattedValue = ''
        if (val === 'yes') {
            formattedValue = 'Yes'
        } else {
            formattedValue = 'No'
        }
        return formattedValue
    }

    const formatAnswer = (programId, sloId, theme) => {
        let programMappings = setup?.mappings[programId]
        let mapping = programMappings?.find(m => m.sloId === sloId)
        let formattedAnswer = 'No'
        if (mapping) {
            if (theme === 1) {
                formattedAnswer = formatYesNo(mapping.firstThemeAnswer)
            } else if (theme === 2) {
                formattedAnswer = formatYesNo(mapping.secondThemeAnswer)
            } else if (theme === 3) {
                formattedAnswer = formatYesNo(mapping.thirdThemeAnswer)
            }
        }
        return formattedAnswer
    }
    
    let assessedPrograms = {}
    if (department && departments.length > 0) {
        var d = departments.find(dept => dept.departmentId === department.departmentId)
        d.programList.forEach((m) => {
            if (m.programId in setup.mappings) {
                assessedPrograms[m.programId] = {
                    id: m.programId,
                    name: m.longName,
                    value: 'yes',
                }
            } else {
                assessedPrograms[m.programId] = {
                    id: m.programId,
                    name: m.longName,
                    value: 'no',
                }
            }
        })
    }

    // Prepare the program learning outcome mappings
    // For each program, display the learning outcome mapping
    let aggregatedMappings = setup?.mappings
    
    let programSubmitters = {}
    let programSubmitDates = {}
    Object.keys(assessedPrograms).forEach((programId) => {
        if (aggregatedMappings) {
            if (programId in aggregatedMappings) {
                aggregatedMappings[programId].forEach((m) => programSubmitters[programId] = m.submittedBy)
                aggregatedMappings[programId].forEach((m) => programSubmitDates[programId] = m.dateSubmitted)
            } else {
                programSubmitters[programId] = ''
                programSubmitDates[programId] = ''
            }
        }
    })

    let departmentLearningOutcomes = learningOutcomes[department?.departmentId]
    let programLearningOutcomes = departmentLearningOutcomes?.learningOutcomes
    
    return (
        <div className="row row-cols-1 row-cols-md-1">
            <div className="p-5 text-center">
                <h3>View Setup</h3>
            </div>

            <div className="text-center pb-4">
                <Row>
                    <Col md="4">
                        <span className="fs-4 m-3">Department</span>
                    </Col>
                    <Col md="8">
                        <span className="fs-4 text-muted">{department?.longName}</span>
                    </Col>
                </Row>
            </div>

            <div className="p-3">
                <h4>Step 1: Identify Programs to Assess</h4>
                <Table striped>
                <thead>
                    <tr>
                        <th>Programs</th>
                        <th className="mx-auto text-center">Will program be assessed in this Report?</th>
                    </tr>
                </thead>
                    <tbody>
                        {
                            Object.keys(assessedPrograms).map((p,k) =>
                                <tr key={k}>
                                    <td className="py-3">{assessedPrograms[p].name}</td>
                                    <td className="mx-auto text-center">
                                        <Form.Label>
                                            {formatYesNo(assessedPrograms[p].value)}
                                        </Form.Label>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>
            <div className="p-3">
                <h4>Step 2: Map Learning Outcomes to Theme</h4>
                {
                    Object.keys(assessedPrograms).map((programId,k) =>
                        <div key={k}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>{assessedPrograms[programId].name}</th>
                                        <th className="text-center">Thinking in Action</th>
                                        <th className="text-center">Practicing Community</th>
                                        <th className="text-center">Professional Skills</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { (programLearningOutcomes && programId in programLearningOutcomes) ? (
                                        programLearningOutcomes[programId].map((mapping, index) => 
                                            <tr key={index}>
                                                <td>
                                                    <LearningOutcomeLabel
                                                        learningOutcomes={learningOutcomes[programId]}
                                                        mapping={mapping}
                                                        />
                                                </td>
                                                <td className="text-center">
                                                    <Form.Label>
                                                        {formatAnswer(programId, mapping.sloId, 1)}
                                                    </Form.Label>
                                                </td>
                                                <td className="text-center">
                                                    <Form.Label>
                                                        {formatAnswer(programId, mapping.sloId, 2)}
                                                    </Form.Label>
                                                </td>
                                                <td className="text-center">
                                                    <Form.Label>
                                                        {formatAnswer(programId, mapping.sloId, 3)}
                                                    </Form.Label>
                                                </td>
                                            </tr>
                                        )
                                    ) :
                                    (
                                        <tr>
                                            <td colSpan={4}>
                                                <span className="fw-bold text-danger">Learning outcomes are unavailable.</span>
                                            </td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    )
                }
            </div>

            <div className="p-3">
                <h4>Step 3: Submit</h4>
                <Table>
                        <thead>
                            <tr>
                                <th>Program</th>
                                <th className="text-center">Is this the official submission for your department?</th>
                                <th>Submitted By</th>
                            </tr>
                        </thead>
                        <tbody>
                        { 
                            Object.keys(assessedPrograms).map((programId,k) =>
                                <tr key={k}>
                                    <td className="py-3"
                                        style={{width: "60%"}}>
                                        {assessedPrograms[programId].name}
                                    </td>
                                    <td className="text-center"
                                        style={{width: "20%"}}>
                                        <Form.Label>
                                            { programSubmitters[programId]
                                                ? 'Yes'
                                                : ''
                                            }
                                        </Form.Label>
                                    </td>
                                    <td className=""
                                        style={{width: "20%"}}>
                                        <Form.Label>
                                            {programSubmitters[programId]}
                                        </Form.Label>
                                    </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </Table>
            </div>
            <div className="p-3 text-center">
                <LinkContainer to={'/setup/edit/' + setupId}>
                    <Button 
                        href={'/setup/edit/' + setupId}
                        variant="primary"
                        size="lg">
                        Modify
                    </Button>
                </LinkContainer>
                {' '}
                <LinkContainer to="/">
                    <Button 
                        href="/"
                        variant="outline-primary"
                        size="lg">
                        Back
                    </Button>
                </LinkContainer>
            </div>
        </div>
    )
}